import { Icon } from '@iconify/react';
import androidFilled from '@iconify/icons-ant-design/android-filled';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography, Button, Box } from '@mui/material';
// utils
import { fShortenNumber, fNumber } from '../../../utils/formatNumber';
import checkOutlined from '@iconify/icons-ant-design/check-outlined';
import ImageSrc from '../../../utils/images/image2.png';

// ----------------------------------------------------------------------
const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(2, 2),
  color: '#22577A',
  backgroundColor: '#ffffff',
  borderColor: theme.palette.primary.main,
  borderWidth: 5,
  height: 'auto',
  minHeight: 300,
  display: "flex",
  flexDirection: 'column',
}));
// ----------------------------------------------------------------------
// calculate total number of active patients (visited practice at least once in last year)
const TOTAL = '8,156';
const AGE = '47';

function AppWeeklySales(props) {
  return (
    <RootStyle>
    <Box 
      sx={{
        height: 'auto',
        minHeight: 208,
        border: 1,
        borderRadius: 2,
        borderColor: "secondary",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxSizing: 'border-box',
        flexGrow: 1,
      }}>
      <Box component="img" src={ImageSrc} sx={{marginTop:2, width: 70, height: 70 }} />
      <br />
      <Typography variant="h5" color='#AA3377'>{fNumber(props.prescriptions.consultations)}</Typography>
      <Typography variant="subtitle2" >
      Number of consultations.
      </Typography>
      <br />
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant="subtitle2" component="span">
        On average, a GP has&nbsp;
          <Typography variant="h5" color='#AA3377' component="span">
            {fNumber(props.prescriptions.average_counsultations)}
          </Typography>
          &nbsp;consultations per day.
        </Typography>
      </Box>
      <br />
      <Button fullWidth style={{ whiteSpace: 'nowrap' }} variant="contained" color='secondary' href='#demographics'>See more on consultations</Button>
    </Box>
    </RootStyle>
  );
}

import { connect } from "react-redux";
const mapState = state => ({
  prescriptions: state.overview.prescriptions
 });
 
 const mapDispatch = ({ 
  overview: {loadData}}) => ({
    loadData: () => loadData()
 });
 
 export default connect(mapState, mapDispatch)(AppWeeklySales);
